var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInboxNodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FC8F37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 15.3333V16C10.0003 16.5304 10.211 17.0391 10.5861 17.4142C10.9612 17.7893 11.4699 18 12.0003 18C12.5308 18 13.0395 17.7893 13.4145 17.4142C13.7896 17.0391 14.0003 16.5304 14.0003 16V15.3333M10.667 7.33333C10.667 6.97971 10.8075 6.64057 11.0575 6.39052C11.3076 6.14048 11.6467 6 12.0003 6C12.3539 6 12.6931 6.14048 12.9431 6.39052C13.1932 6.64057 13.3337 6.97971 13.3337 7.33333C14.0993 7.69535 14.7519 8.25888 15.2217 8.96353C15.6915 9.66818 15.9606 10.4874 16.0003 11.3333V13.3333C16.0505 13.7478 16.1973 14.1447 16.4289 14.4921C16.6605 14.8395 16.9704 15.1276 17.3337 15.3333H6.66699C7.03028 15.1276 7.3402 14.8395 7.57178 14.4921C7.80337 14.1447 7.95016 13.7478 8.00033 13.3333V11.3333C8.04003 10.4874 8.30919 9.66818 8.77896 8.96353C9.24872 8.25888 9.90139 7.69535 10.667 7.33333Z",
    stroke: "#FFF4F0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxNodeIcon);
export default __webpack_public_path__ + "static/media/inboxNodeIcon.10e7c5e999a71597dc1df58eaee3382f.svg";
export { ForwardRef as ReactComponent };